import { render, staticRenderFns } from "./serviceDetail.vue?vue&type=template&id=45e77a9a&scoped=true&"
import script from "./serviceDetail.vue?vue&type=script&lang=js&"
export * from "./serviceDetail.vue?vue&type=script&lang=js&"
import style0 from "./serviceDetail.vue?vue&type=style&index=0&id=45e77a9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e77a9a",
  null
  
)

export default component.exports